<script>
	let enlargeBool = false
	let enlargedImage
	const enlargeImage = (imageData) => {
		enlargedImage = {
			URL: imageData.URL,
			name: imageData.name
		}
		enlargeBool = true
	}
</script>

<main>
    <div id="lower" class="lower">
		<!--Main loop for showing the list of images-->
        <iframe title="Restaurant Location" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d204.08527215480476!2d-106.5865534!3d35.072628!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87220b03e62207d3%3A0x1bc741f8f90b6c88!2s2000%20Vietnam%20Restaurant!5e0!3m2!1sen!2sus!4v1696878043882!5m2!1sen!2sus" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
</main>

<style>
    .lower > iframe {
        width: 100%;
		height: 75vh;
    }
</style>